var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 13,
    cy: 13,
    r: 13
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#007AC3",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85BC20",
    mask: "url(#b)",
    d: "M3.824 3.824h18.353v18.353H3.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D1EA",
    mask: "url(#b)",
    d: "M0 9.941h26v6.118H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409BD2",
    mask: "url(#b)",
    d: "M9.941 9.941H26v6.118H9.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A6D1EA",
    mask: "url(#b)",
    d: "M9.941 0h6.118v26H9.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409BD2",
    mask: "url(#b)",
    d: "M9.941 9.941h6.118V26H9.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4CD58",
    mask: "url(#b)",
    d: "M9.941 9.941h12.235v12.235H9.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4E8B1",
    mask: "url(#b)",
    d: "M3.824 3.824h12.235v12.235H3.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#409BD2",
    mask: "url(#b)",
    d: "M0 0h9.941v9.941H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5202E",
    mask: "url(#b)",
    d: "M9.941 9.941h6.118v6.118H9.941z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A4CD58",
    mask: "url(#b)",
    d: "M3.824 3.824h6.118v6.118H3.824z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85BC20",
    mask: "url(#b)",
    d: "M16.059 16.059h6.118v6.118h-6.118z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#474747"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.938 23.75h.483c.098 0 .185.012.248.035.204.058.303.206.303.376 0 .241-.19.366-.366.407v.007c.106.05.27.347.456.675H24.7c-.205-.356-.326-.592-.393-.597h-.054v.597h-.315v-1.5zm.39.663c.163 0 .306-.062.306-.216 0-.092-.041-.162-.126-.183a.433.433 0 00-.171-.023h-.084v.422h.076z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 24.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm-1.5-1.184a1.184 1.184 0 100 2.368 1.184 1.184 0 000-2.368z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelMedium);
export default __webpack_public_path__ + "static/media/wheel-medium.0cc90dc9204cbc72faa637f57befa85c.svg";
export { ForwardRef as ReactComponent };